<template>
  <div id="wrapper" class="gray-bg load-bg">

    <div class="container">

      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">

          <div class="login" >

            <div class="logo" v-if="token">
              <h1>{{ load.reference_number }}</h1>
            </div>
            <div class="logo" v-else>
              <h1>Submit Load</h1>
            </div>

            <form role="form" v-if="token" class="submit-load-details">
              <weighbridge-details :full-width="true" :stored-callback="showSuccess"></weighbridge-details>
            </form>

            <form role="form" class="submit-load-details" v-else-if="successful">

              <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: block; margin-top: 0; margin-bottom: 20px">
                <div class="swal2-success-circular-line-left" style="background: rgb(255, 255, 255);"></div>
                <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
                <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
                <div class="swal2-success-ring"></div>
                <div class="swal2-success-fix" style="background: rgb(255, 255, 255);"></div>
                <div class="swal2-success-circular-line-right" style="background: rgb(255, 255, 255);"></div>
              </div>

						<div class="margin-20"></div>

						<div class="text-center">
							<p class="m-b-lg lead">Load details succcessfully submitted.</p>

							<a @click="successful = false" class="btn btn-info btn-lg m-b-sm">Submit Another Load</a>
						</div>

					  </form>

            <form role="form" v-else>

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Load Reference Number</label>
                  <input type="text" v-model="reference_number" class="form-control" placeholder="Load Reference Number" v-float-label/>
                </div>
              </div>

              <ladda-button :on-click="handleCheckReference" :max-width="true" type="success">Check Reference Number</ladda-button>

            </form>

            <div class="login-footer">
              <div class="row">
                <div class="col-xs-7">
                  <router-link :to="{ name: 'auth.login' }" href="login.php">Account Login</router-link>
                </div>
              </div><!-- /.row -->
            </div><!-- /.login-footer -->

          </div><!-- /.login -->

        </div>
      </div><!-- /.login -->

    </div>

  </div>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { SET_TOKEN, RESET_LOAD, SET_LOAD, SET_JOB, RESET_JOB } from 'vx/mutations'
  import LaddaButton from 'components/forms/LaddaButton'
  import WeighbridgeDetails from 'components/loads/weighbridge/WeighbridgeDetails'
  import { notify } from 'utils'

  export default {
    components: {
      LaddaButton,
      WeighbridgeDetails
    },

    data () {
      return {
        reference_number: null,
        successful: false
      }
    },

    created () {
      this[SET_TOKEN](null)
      this[RESET_LOAD]()
    },

    computed: {
      ...mapState('load', ['load', 'token'])
    },

    methods: {
      ...mapActions('load', ['findLoadByReference']),
      ...mapMutations('load', [SET_TOKEN, RESET_LOAD, SET_LOAD]),
      ...mapMutations('job', [SET_JOB, RESET_JOB]),

      handleCheckReference () {
        const notifyError = () => {
          notify.error('Load could not be retrieved')
        }

        let payload = {
          reference_number: this.reference_number
        }

        return this.findLoadByReference(payload).then(response => {
          this[SET_LOAD](response.data.load)
          this[SET_JOB](response.data.load.job)
          this[SET_TOKEN](response.data.token)
        }).catch(notifyError)
      },

      showSuccess () {
        this[SET_TOKEN](null)
        this[RESET_LOAD]()
        this[RESET_JOB]()

        this.successful = true
        this.reference_number = null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SubmitLoad.vue?0e416093